import styled, { css } from 'styled-components';
import Button from '../../../../_shared/components/Button';
import Icon from '../../../../_shared/components/Icon';

export const MapContainer = styled.div`
  width: 100%;
  height: 100%;
  opacity: ${props => props.overlay && '0.5'};

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    position: fixed;
  }

  .marker-position {
    top: 28px;
    right: 25px;
    position: relative;
  }

  .marker-multiple-position {
    position: relative;
    top: -3px;
  }

  .cluster-style > div {
    top: 10px;
    left: -7px;
  }
`;

export const MapTile = styled.div`
  width: 100%;
  height: 100%;
`;

export const MapOverlay = styled.div`
  z-index: 5000;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
`;

export const DisplayInfo = styled.div`
  background-color: ${({ theme }) => theme.COLORS.BASE};
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  width: 339px;
  max-height: 317px;
  overflow-y: auto;
  padding: 0 18px;
  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    width: 18px;
    background: ${({ theme }) => theme.COLORS.BASE};
    border: 6px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-button {
    height: 24px;
  }

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    position: absolute;
    bottom: 96px;
    left: 50%;
    transform: translate(-50%, -48px);
  }

  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.VDP_DESKTOP_WL}) {
    position: absolute;
    bottom: 18px;
    right: 18px;
  }
`;

const DisplayInfoItemVariants = {
  single: css``,
  multiple: css`
    border-bottom: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};

    &:nth-child(2) {
      padding-top: 11px;
    }
  `
};

DisplayInfo.Item = styled.div`
  background-color: ${({ theme }) => theme.COLORS.BASE};
  ${props => DisplayInfoItemVariants[props.variant]};
  padding: 18px 0;

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
  }

  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.VDP_DESKTOP_WL}) {
    width: 100%;
    max-height: 175px;
    ${props => DisplayInfoItemVariants[props.variant]};
  }
`;

DisplayInfo.Heading = styled.div`
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  margin-bottom: 9px;
`;

DisplayInfo.SubHeading = styled.div`
  margin-bottom: 10px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

DisplayInfo.Confirm = styled.div`
  margin-bottom: 12px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
`;

DisplayInfo.Button = styled(Button.Primary)`
  width: 100%;
  height: 36px;
`;

DisplayInfo.Size = styled.div`
  padding-top: 18px;
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  letter-spacing: 1.2px;
`;

DisplayInfo.Close = styled(Icon).attrs({
  icon: 'TR5-Close_X'
})`
  width: 18px;
  height: 18px;
  margin-right: 12px;
  cursor: pointer;

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    width: 18px;
    height: 18px;
    margin-right: 12px;
  }

  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.VDP_DESKTOP_WL}) {
    display: none;
  }
`;
